import { SET_COMPLETEDRIDE } from '../actions';

const completedride = (state = [], action) => {
  switch (action.type) {
	case SET_COMPLETEDRIDE:
      return [...action.value];  
    default: return state;
  }
}

export default completedride;
